import {
  Component,
  EventEmitter,
  Input,
  ModuleWithProviders,
  Output,
  Type,
} from '@angular/core';
import { ColumnOptions } from '@cai-services';
import {
  CdkDragDrop,
  CdkDropList,
  CdkDrag,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'common-dnd-list',
  imports: [CdkDropList, CdkDrag, FormsModule],
  templateUrl: './dnd-list.component.html',
  styleUrls: ['./dnd-list.component.scss'],
})
export class DndListComponent {
  @Input() columnOptions: ColumnOptions[];
  @Input() isAllInRate: boolean;
  @Output() columnOptionChange = new EventEmitter<ColumnOptions[]>();

  constructor() {}

  drop(event: CdkDragDrop<ColumnOptions[]>): void {
    moveItemInArray(
      this.columnOptions,
      event.previousIndex,
      event.currentIndex,
    );
    if (
      this.columnOptions?.[event?.currentIndex + 1]?.locked &&
      !this.columnOptions?.[event?.currentIndex + 1]?.disabled
    ) {
      this.columnOptions[event.currentIndex].locked = true;
    }
    if (!this.columnOptions?.[event?.currentIndex + 1]?.locked) {
      this.columnOptions[event.currentIndex].locked = false;
    }
    this.columnOptionChange.emit(this.columnOptions);
  }

  private isApplicableOption(option: ColumnOptions): boolean {
    return ![
      'fuelSurcharge',
      'securitySurcharge',
      'miscellaneousCharge',
      'contacts',
    ].includes(option.value);
  }

  get isAllSelected(): boolean {
    if (!this.columnOptions?.length) {
      return false;
    }
    if (this.isAllInRate) {
      return this.columnOptions
        .filter((option) => this.isApplicableOption(option))

        .every((option) => option.selected);
    } else {
      return this.columnOptions.every((option) => option.selected);
    }
  }
  toggleSelectAll(event: Event): void {
    if (!this.columnOptions?.length) {
      return;
    }
    let applicableOptions = this.columnOptions.filter(
      (option) => !option.disabled,
    );
    if (this.isAllInRate) {
      applicableOptions = applicableOptions.filter((option) =>
        this.isApplicableOption(option),
      );
    }

    const allSelected = applicableOptions.every((option) => option.selected);
    applicableOptions.forEach((option) => {
      option.selected = !allSelected;
    });

    this.onSelectionChange();
  }

  onSelectionChange(): void {
    this.columnOptionChange.emit(this.columnOptions);
  }

  onLockChange(index: number): void {
    let lastLockedIndex;
    this.columnOptions.forEach((option, i) => {
      if (option.locked && !option.disabled) {
        lastLockedIndex = i;
      }
    });

    this.columnOptions[index].locked = !this.columnOptions[index].locked;

    if (this.columnOptions?.[index]?.locked) {
      moveItemInArray(
        this.columnOptions,
        index,
        lastLockedIndex === undefined ? 0 : lastLockedIndex + 1,
      );
    }

    if (
      !this.columnOptions?.[index]?.locked &&
      this.columnOptions?.[index + 1]?.locked
    ) {
      moveItemInArray(
        this.columnOptions,
        index,
        lastLockedIndex === undefined ? 0 : lastLockedIndex,
      );
    }

    this.columnOptionChange.emit(this.columnOptions);
  }
}
